import "./CacheItemActions.scss";

import React, { useEffect, useState } from "react";
// import { Button } from 'react-bootstrap';
import { Dropdown } from "react-bootstrap";
import { useNavigate } from "react-router";
import { useParams } from "react-router-dom";

import { DeleteCacheItemPopup } from "../../../../components/DeleteCacheItemPopup/DeleteCacheItemPopup";
// import { ArrowIcon } from '../../../../components/icons/ArrowIcon';
import { ThreeDotsIcon } from "../../../../components/icons/ThreeDotsIcon";
import { useOrganizationContext } from "../../../../contexts/organizations/organizationsContext";
import { useDeleteCacheItem } from "../../../../hooks/reactQueryHooks/useCacheItems";

interface IProps {
  isDisabledDeleteBtn: boolean;
  applicationId: string;
}

const CacheItemActions: React.FC<IProps> = ({
  applicationId,
  isDisabledDeleteBtn,
}) => {
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
  const navigate = useNavigate();

  const deleteMutation = useDeleteCacheItem();
  const { currentOrganization } = useOrganizationContext();
  const handleClickDelete = () => {
    setShowDeleteModal(true);
    deleteMutation.reset();
  };

  const { id } = useParams();

  const handleDelete = () => {
    onDeleteItem(id || "", applicationId);
  };

  const onDeleteItem = (cacheItemId: string, applicationId: string) => {
    deleteMutation.mutate({
      cacheItemId,
      organizationId: currentOrganization?.id || "",
      applicationId: applicationId,
    });
  };

  useEffect(() => {
    if (deleteMutation.isSuccess) {
      setShowDeleteModal(false);
      navigate("/safety-compliance/cache");
    }
  }, [deleteMutation.isSuccess, navigate]);

  const handleCancelDelete = () => {
    setShowDeleteModal(false);
  };

  return (
    <div className="action-wrapper" data-testid="cache-item-actions">
      {/* 
      Do not remove this code snippet, it will be used for switch between items
      <Button
        onClick={prev}
        variant="light"
      >
        <ArrowIcon />
      </Button>

      <Button
        onClick={next}
        variant="light"
        className="to-right"
      >
        <ArrowIcon />
      </Button> */}
      <Dropdown>
        <Dropdown.Toggle
          variant="outline-light"
          className="no-arrow"
          data-testid="dropdown-toggle"
        >
          <ThreeDotsIcon />
        </Dropdown.Toggle>
        <Dropdown.Menu renderOnMount={false}>
          <Dropdown.Item
            className={`${isDisabledDeleteBtn ? "disabled" : ""}`}
            data-testid="dropdown-delete"
            onClick={handleClickDelete}
          >
            <span>Delete</span>
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>

      {showDeleteModal && (
        <DeleteCacheItemPopup
          onCancel={handleCancelDelete}
          onSubmit={handleDelete}
          isProcessing={deleteMutation.isLoading}
          isError={deleteMutation.isError}
        />
      )}
    </div>
  );
};

export { CacheItemActions };
